export default function displayName(value) {
  if (!value) {
    return undefined;
  }

  return (value.firstName + " " + value.lastName).trim();
}
